/* eslint-disable */
export default function setup() {
	console.defaultError = console.error.bind(console);
	console.defaultWarn = console.warn.bind(console);
	console.defaultInfo = console.info.bind(console);

	console.errors = [];
	console.warnings = [];
	console.infos = [];

	console.info = function() {
		console.defaultInfo.apply(console, arguments);
		Array.from(arguments).forEach(a => {
			console.infos.push('INFO: ' + a);
		});
	};

	console.warn = function() {
		console.defaultWarn.apply(console, arguments);

		Array.from(arguments).forEach(a => {
			console.warnings.push('WARN: ' + a);
		});
	};

	console.error = function() {
		console.defaultError.apply(console, arguments);

		Array.from(arguments).forEach(a => {
			console.errors.push('ERROR: ' + a);
		});
	};
}

/* eslint-enable */
